import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Form, Card, Alert,
} from 'react-bootstrap';
import { Content, PosterImg } from './styles';

const Poster = ({
  changeFile, alertPoster,
}) => {
  const [preview, setPreview] = useState(null);
  const handleImageChange = (e) => {
    changeFile({
      image: e.target.files[0],
    });
    setPreview(URL.createObjectURL(e.target.files[0]));
  };

  return (
    <Content>
      <div className="form-container poster">
        <Card>
          <Card.Header>Poster</Card.Header>
          <Card.Body>
            {preview && (
              <>
                <p>
                  Preview
                </p>
                <PosterImg src={preview} alt="preview" />
              </>
            )}
            {alertPoster && (
            <Alert variant="danger">
              {alertPoster}
            </Alert>
            )}
            <Card.Title>Update poster</Card.Title>
            <Form.Control data-testid="inputPoster" type="file" accept="image/png, image/jpeg" onChange={handleImageChange} />
          </Card.Body>
        </Card>
      </div>
    </Content>
  );
};

Poster.defaultProps = {
  alertPoster: '',
  changeFile: () => {},
};

Poster.propTypes = {
  alertPoster: PropTypes.string,
  changeFile: PropTypes.func,
};

export default Poster;
